import axios from "axios";
import { adminApi } from "../../lib/axios";

export interface AdminSnapshot {
  id: string;
  status: "IN_PROGRESS" | "COMPLETED";
  totalBrands: number;
  activeBrands: number;
  totalAffiliates: number;
  totalAffiliateSalesCount: number;
  totalAffiliateSalesAmount: number;
  totalCampaignSalesCount: number;
  totalCampaignSalesAmount: number;
  timeframeStart: string;
  timeframeEnd: string;
  createdAt: string;
  notes?: string | null;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface ListSnapshotsResponse {
  data: AdminSnapshot[];
  pagination: Pagination;
}

class AdminAnalyticsService {
  async generateSnapshot(payload?: {
    timeframeStart?: string;
    timeframeEnd?: string;
    notes?: string;
  }): Promise<{ status: string; id: string }> {
    try {
      const { data } = await adminApi.post(
        "/analytics/admin/snapshots/generate",
        payload || {}
      );
      return data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          error.response?.data?.message || "Failed to start snapshot generation"
        );
      }
      throw new Error("An unexpected error occurred");
    }
  }

  async listSnapshots(params?: { page?: number; limit?: number }): Promise<ListSnapshotsResponse> {
    try {
      const search = new URLSearchParams();
      if (params?.page !== undefined) search.append("page", String(params.page));
      if (params?.limit !== undefined) search.append("limit", String(params.limit));
      const { data } = await adminApi.get(
        `/analytics/admin/snapshots${search.toString() ? `?${search.toString()}` : ""}`
      );
      return data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          error.response?.data?.message || "Failed to fetch snapshots"
        );
      }
      throw new Error("An unexpected error occurred");
    }
  }
}

export const adminAnalyticsService = new AdminAnalyticsService();


